import { assets } from '../../assets';
import { Direction } from '../../logic/graphql/types/types.d';

export const getDirectionText = (direction?: Direction | null) => {
  switch (direction) {
    case Direction.Buy:
      return 'buy';
    case Direction.Sell:
      return 'sell';
    default:
      return 'notification';
  }
};

export const getDirectionIcon = (direction?: Direction | null) => {
  switch (direction) {
    case Direction.Buy:
      return assets.icons.notification_buy;
    case Direction.Sell:
      return assets.icons.notification_sell;
    default:
      return assets.icons.notification;
  }
};
